export * from './editable-text-v2'
import EditableTextV2 from './editable-text-v2'
export default EditableTextV2
